import config from "config"
import _ from "lodash"
import { useGeoLocation } from "providers/geolocation"
import { useMemo } from "react"
import { useLocation } from "react-router-dom"

export interface IUseMobileUrlProps {
  path?: string
}

export type UseMobileUrl = (props?: IUseMobileUrlProps) => { mobileUrl: string }

export const useMobileUrl: UseMobileUrl = (props = {}) => {
  const { path } = props
  const mobileBaseUrl = config("mobileBaseUrl")
  const location = useLocation()
  const { deviceLocation, deviceLocationName } = useGeoLocation()
  const mobileUrl = useMemo(
    () =>
      mobileBaseUrl
        ? `${mobileBaseUrl}${path || location.pathname}?user-location=${_.get(
            deviceLocation,
            "id",
            ""
          )}&location-name=${deviceLocationName || ""}`
        : "",
    [mobileBaseUrl, deviceLocationName, deviceLocation, path, location]
  )
  return {
    mobileUrl,
  }
}
